<template>
  <div class="all-group-classes-card">
    <va-card title="Group Classess">
      <h2>Basic Manners</h2>
      <basic-manners-classes />
      <router-link :to="{name: 'basic-manners'}">
        <va-button>
          View Basic Manners curriculum
        </va-button>
      </router-link>
      <!-- <h2>Reactive Rover</h2>
      <reactive-rover-classes />
      <router-link :to="{name: 'reactive-rover'}">
        <va-button>
          View Reactive Rover curriculum
        </va-button>
      </router-link> -->
      <h2>Outside Manners</h2>
      <outside-manners-classes />
      <router-link :to="{name: 'outside-manners'}">
        <va-button>
          View Outside Manners curriculum
        </va-button>
      </router-link>
      <!-- <h2>Brewery Manners</h2>
      <span> Coming Soon! </span> -->
      <mailing-list-signup
        description="Join our mailing list to be notified when more classes are scheduled." />
      <!-- <div class="social-media">
        Follow us on
        <a href="https://fb.me/RewardingDogTraining"
          alt="Facebook"
          target="_blank"
          rel="noopener noreferrer"
          class="link link-resources"
          :style="{color: this.$themes.primary}" >Facebook</a>
        or
        <a href="https://www.instagram.com/rewardingdogtraining/"
          alt="Instagram"
          target="_blank"
          rel="noopener noreferrer"
          class="link link-resources"
          :style="{color: this.$themes.primary}" >Instagram</a>
        to find out when new group classes are added!</div> -->
      <contact-group-class />
    </va-card>
  </div>
</template>

<script>
import BasicMannersClasses from '../sub-components/BasicMannersClasses'
import OutsideMannersClasses from '../sub-components/OutsideMannersClasses'
// import ReactiveRoverClasses from '../sub-components/ReactiveRoverClasses'
import MailingListSignup from '../sub-components/MailingListSignup'
import ContactGroupClass from '../sub-components/ContactGroupClass'

export default {
  name: 'all-group-classes-card',
  components: {
    BasicMannersClasses,
    // ReactiveRoverClasses,
    OutsideMannersClasses,
    MailingListSignup,
    ContactGroupClass,
  },
}
</script>

<style scoped lang="scss">
.all-group-classes-card {
  .va-card__body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .va-button {
      border-radius: 0.375rem;
      width: 100%;

      &__content {
        font-size: 1.3rem;
        font-family: Montserrat, sans-serif;

        &__title {
          font-size: 1.3rem;
        }
      }
    }

    h2 {
      width: 100%;
      text-align: center;
      border-bottom: 1px solid $gray;
      margin: 1rem 0;
    }

    .mailing-list-signup,
    .social-media {
      margin: 2rem 1rem 0;
    }
  }
}
</style>
